module.exports = __webpack_public_path__ + "img/xiaozi_2x.b6a3f558.png";